<template>
  <div>
    <Hero/>
    <Banner :message="news"/>
    <Content class="gallery" :news="news">
      <div id="order-wrapper">
        <router-link
          class="pure-button button-xlarge"
          id="order-button"
          :to="{ name: 'orderForm' }"
        >
          <font-awesome-icon icon="utensils-alt"/>&nbsp; Order a Custom Bake
        </router-link>
        <br>
        <a class="pure-button button-large" id="vip-button" @click.prevent="scrollToFooter">
          <font-awesome-icon icon="envelope"/>&nbsp; Join VIP List
        </a>
      </div>
      <Testimonial :testimonial="testimonial" v-if="testimonial"/>
      <hr class="invisible" v-show="testimonial">
      <Event v-for="event in events" :key="event.id" :event="event.data()"/>
      <hr class="invisible" v-show="events.length > 0">
      <hr class="invisible" v-show="events.length > 0">
      <p class="filters">
        <button
          class="pure-button button-xsmall"
          :class="{ 'button-filter' : this.filters.includes('birthday-cake') }"
          @click.prevent="toggleFilter('birthday-cake')"
        >
          <font-awesome-icon :icon="['far', 'birthday-cake']"></font-awesome-icon>&nbsp;Cakes
        </button>
        <button
          class="pure-button button-xsmall"
          :class="{ 'button-filter' : this.filters.includes('cookie-bite') }"
          @click.prevent="toggleFilter('cookie-bite')"
        >
          <font-awesome-icon :icon="['fas', 'cookie-bite']"></font-awesome-icon>&nbsp;Cookies
        </button>
        <button
          class="pure-button button-xsmall"
          :class="{ 'button-filter' : this.filters.includes('hamburger') }"
          @click.prevent="toggleFilter('hamburger')"
        >
          <font-awesome-icon :icon="['far', 'hamburger']"></font-awesome-icon>&nbsp;Macarons
        </button>
        <button
          class="pure-button button-xsmall"
          :class="{ 'button-filter' : this.filters.includes('cauldron') }"
          @click.prevent="toggleFilter('cauldron')"
        >
          <font-awesome-icon :icon="['fas', 'cauldron']"></font-awesome-icon>&nbsp;Other
        </button>
      </p>
      <Bake v-for="bake in filteredBakes" :key="bake.id" :bake="bake.data()"/>
    </Content>
  </div>
</template>

<script>
import Moment from 'moment'
import Banner from '@/components/Banner.vue'
import Hero from '@/components/Hero.vue'
import Testimonial from '@/components/Testimonial.vue'
import Event from '@/components/Event.vue'
import Bake from '@/components/Bake.vue'

export default {
  name: 'Gallery',
  components: { Banner, Hero, Testimonial, Event, Bake },
  data() {
    return {
      news: null,
      bakes: [],
      events: [],
      filters: [],
      testimonial: null
    }
  },
  computed: {
    filteredBakes() {
      if (this.filters.length === 0) {
        return this.bakes
      } else {
        return this.bakes.filter(bake =>
          this.filters.includes(bake.data().icon[1])
        )
      }
    }
  },
  methods: {
    scrollToFooter() {
      window.scrollTo(0, document.body.scrollHeight)
    },
    getBanner() {
      this.$database
        .collection('news')
        .doc('alert')
        .get()
        .then(result => {
          if (result.data().message !== '') {
            this.news = result.data().message
          }
        })
    },
    getBakes() {
      this.$database
        .collection('bakes')
        .orderBy('date', 'desc')
        .get()
        .then(collection => (this.bakes = collection.docs))
    },
    getEvents() {
      this.$database
        .collection('events')
        .orderBy('date', 'asc')
        .where('date', '>', Moment().format())
        .get()
        .then(collection => (this.events = collection.docs))
    },
    getTestimonials() {
      this.$database
        .collection('testimonials')
        .where('visible', '==', true)
        .get()
        .then(collection => {
          if (collection.docs.length > 0) {
            this.testimonial = collection.docs[
              Math.floor(Math.random() * collection.docs.length)
            ].data()
          }
        })
    },
    toggleFilter(f) {
      if (this.filters.includes(f)) {
        this.filters = this.filters.filter(x => x !== f)
      } else {
        this.filters.push(f)
      }
    }
  },
  mounted() {
    this.getBanner()
    this.getTestimonials()
    this.getEvents()
    this.getBakes()
  }
}
</script>

<style lang="less" scoped>
.gallery {
  text-align: center;

  #order-wrapper {
    display: none;

    #vip-button {
      margin-top: 1em;
    }
  }

  hr {
    border: none;
    border-top: 1px dashed #b7e6e2;
  }

  hr.invisible {
    margin: 1.5em auto;
    border: none;
  }

  .filters .pure-button {
    margin: 3px;
    border-radius: 26.7px;
  }
}

@media (max-width: 1024px) {
  .gallery #order-wrapper {
    display: block;
    margin-bottom: 5em;
    margin-top: 1em;
    background-color: #fefefe;
  }
}

@media (max-width: 480px) {
  .gallery .filters .pure-button {
    margin: 3px 1px;
    border-radius: 26.7px;
  }
}
</style>
